import { Pricing } from "../components/Pricing";
import PageWithNavbar from "@/components/PageWithNavbar";

const PricingPage = () => {
  return (
    <PageWithNavbar>
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="mx-auto text-left mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mx-auto text-left">
            Doyen <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">Pricing</span>
          </h1>
          <p className="text-xl text-muted-foreground mt-2" >
            You own what you pay for. Try our Free version, and stick with it if it meets your needs.
          </p>
        </div>
        <Pricing />
        </div>
    </div>
    </PageWithNavbar>
  );
}

export default PricingPage;